import * as React from "react";

function SvgSuspendIcon(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={17} height={17} {...props}>
        <path
          d="M8.5 0a8.444 8.444 0 00-6.01 2.49A8.445 8.445 0 000 8.5a8.444 8.444 0 002.489 6.01A8.444 8.444 0 008.5 17a8.445 8.445 0 006.011-2.489A8.444 8.444 0 0017 8.5a8.445 8.445 0 00-2.49-6.011A8.445 8.445 0 008.5 0zm0 15.8a7.264 7.264 0 01-2.842-.572 7.32 7.32 0 01-2.322-1.566 7.271 7.271 0 01-1.566-2.318A7.25 7.25 0 011.2 8.5a7.27 7.27 0 01.572-2.843 7.334 7.334 0 011.566-2.322A7.271 7.271 0 015.66 1.769 7.25 7.25 0 018.5 1.2a7.259 7.259 0 012.843.573 7.321 7.321 0 012.322 1.565 7.277 7.277 0 011.566 2.323A7.25 7.25 0 0115.8 8.5a7.253 7.253 0 01-.573 2.842 7.264 7.264 0 01-1.567 2.322 7.271 7.271 0 01-2.318 1.566 7.238 7.238 0 01-2.842.57zm2.574-10.492a.6.6 0 00-.6.6v5.18a.6.6 0 00.6.6.6.6 0 00.6-.6v-5.18a.6.6 0 00-.601-.595zm-5.147 0a.6.6 0 00-.6.6v5.18a.6.6 0 00.6.6.6.6 0 00.6-.6v-5.18a.6.6 0 00-.6-.595z"
          fill="#3c4252"
        />
      </svg>
    </span>
  );
}

export default SvgSuspendIcon;
